import {
    GET_GPS_DEVICE_REQUEST,
    GET_GPS_DEVICE_SUCCESS,
    GET_GPS_DEVICE_FAILURE,
    SET_GPS_DEVICE
} from '../actions/gps_devices';
import { buildGpsDevices } from '../helpers/gps_devices';
const initialState = {
    gps_device: {},
    fetching: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_GPS_DEVICE_REQUEST: {
            return {
                ...state,
                fetching: true
            };
        }
        case GET_GPS_DEVICE_SUCCESS: {
            return {
                ...state,
                fetching: false,
                gps_device: buildGpsDevices(action.payload.gps_device)
            };
        }
        case GET_GPS_DEVICE_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        case SET_GPS_DEVICE: {
            return {
                ...state,
                gps_device: action.payload.gps_device
            };
        }
        default:
            return state;
    }
};
